import React, { Suspense } from 'react'
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DevicesList from '../../pages/publisher/devices/DevicesList';
import Device from '../../pages/publisher/devices/Device';
import RemoteConfiguration from '../../components/sdk/RemoteConfiguration';
import { get } from 'lodash';

const Devices = () => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route
            exact
            path={`${path}/:sptId/sdk/remote_configuration`}
            component={
              (props)=>(
                <RemoteConfiguration configurable={
                  {
                    remote_configurable_id: get(props, 'match.params.sptId'),
                    remote_configurable_type: 'Device',
                  }
                }/>
              )}
          />
        <Route exact path={`${path}/:sptId`} component={Device}/>
        <Route exact path={path} component={DevicesList}/>
      </Switch>
    </Suspense>

   );
}

export default Devices;
